<!--  -->
<template>
  <v-dialog v-model="showDialog" no-click-animation persistent :width="width">
    <form @submit.prevent="$emit('ok')">
      <v-card>
        <v-card-title class="font-weight-bold">{{ title }}</v-card-title>
        <v-divider />
        <v-card-text style="padding: 20px">
          <slot />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            v-if="showCancel"
            width="80"
            height="30"
            depressed
            @click="$emit('update:value', false)"
          >{{ cancelText }}
          </v-btn>
          <v-btn
            v-if="showConfirm"
            width="80"
            height="30"
            color="primary"
            depressed
            type="submit"
          >{{ confirmText }}</v-btn>
        </v-card-actions>
      </v-card>
    </form>
  </v-dialog>
</template>

<script>
export default {
  name: 'ReDialog',
  props: {
    title: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 500,
    },
    showCancel: {
      type: Boolean,
      default: true,
    },
    showConfirm: {
      type: Boolean,
      default: true,
    },
    cancelText: {
      type: String,
      default: '取消',
    },
    confirmText: {
      type: String,
      default: '确定',
    },
  },
  data() {
    return {
      showDialog: this.modelValue,
    };
  },
  watch: {
    value: {
      handler(newVal) {
        this.showDialog = newVal;
      },
      immediate: true,
    },
  },
};
</script>

<style lang="" scoped></style>
